import React, { useContext, useState } from 'react'
import BabaForm from 'components/forms/Index'
import NavigationButtons from 'components/bookings/NavigationButtons'
import PropTypes from 'prop-types'
import CheckoutContext from 'components/bookings/contexts/CheckoutContext'

const MessageForm = ({
  authenticityToken,
  personalizedMessage,
  updatePersonalizedMessageURL,
  onOrderModification,
  giftCardsURL,
  priceAfter
}) => {
  const context = useContext(CheckoutContext)
  const [errors, setErrors] = useState(null)

  const onSuccess = (data) => {
    context.stopLoading()
    onOrderModification(data)
    context.handleValidationSuccessful()
  }

  const onError = (data) => {
    context.stopLoading()
    setErrors(data.errors)
  }

  return (
    <BabaForm.BabaForm
      didSubmit={context.startLoading}
      authenticity_token={authenticityToken}
      remote
      action={updatePersonalizedMessageURL}
      method="PATCH"
      success={onSuccess}
      error={onError}>
      <div className="step-title">Carte cadeau</div>
      <div className="row">
        <div className="col-xs-12">
          <BabaForm.BabaErrors errors={errors} />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <p>
            Dès que la commande sera finalisée, vous recevrez un e-mail de
            confirmation qui vous permettra de télécharger immédiatement la
            carte cadeau.
            <br />
            Vous pourrez alors imprimer la carte ou la transmettre par e-mail au
            bénéficiaire.
          </p>
          <BabaForm.BabaInput
            id="personalizedMessage"
            type="textarea"
            maxlength={170}
            objectName="gift_card_order"
            fieldName="personalized_message"
            placeHolder="Message pour le destinataire"
            helpBlock="170 caractères max"
            rows={4}
            hideLabel
            defaultValue={personalizedMessage}
          />
          <NavigationButtons
            previousStepURL={giftCardsURL}
            priceAfter={priceAfter}
            goPrevious={context.goPrevious}
            submitLabel="Suivant"
            handleValidate={null}
          />
        </div>
      </div>
    </BabaForm.BabaForm>
  )
}

MessageForm.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
  personalizedMessage: PropTypes.string,
  updatePersonalizedMessageURL: PropTypes.string.isRequired,
  onOrderModification: PropTypes.func.isRequired,
  giftCardsURL: PropTypes.string.isRequired,
  priceAfter: PropTypes.string.isRequired
}

export default MessageForm
